import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }

import Co2AverageForm from '@/components/co2quiz/Co2AverageForm.vue';
import ListFilter from '@/components/common/ListFilter.vue';
import CurrentLanguage from '@/components/CurrentLanguage.vue';
import { Co2CountryAverage } from '@/models/co2-quiz.model';
import { useEvents, Event } from '@/services/events.composable';
import { Mutations, ShiftCMSState } from '@/store';
import {
  Co2QuizStoreActions,
  Co2QuizStoreState,
} from '@/stores/co2-quiz.store';
import { computed, markRaw, onBeforeUnmount, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { countryName, OneEarth } from '@/models/country.model';


export default /*@__PURE__*/_defineComponent({
  __name: 'Co2Averages',
  setup(__props) {

const store = useStore<ShiftCMSState & { co2: Co2QuizStoreState }>();
const events = useEvents();

const questions = computed<Co2CountryAverage[]>(() => store.state.co2.averages);

const update = () => {
  store.dispatch(Co2QuizStoreActions.GetCo2Averages);
};

onMounted(() => {
  events.on(Event.LanguageChanged, update);
  update();
});

onBeforeUnmount(() => {
  events.off(Event.LanguageChanged, update);
});

const headers = [
  { title: 'ID', key: 'id', sortable: false, width: '5%' },
  { title: 'Country', key: 'country', width: '15%' },
  { title: 'Category', key: 'categories', width: '25%' },
  { title: 'Average', key: 'value', width: '20%' },
  { title: 'State', key: 'translated', sortable: false, width: '35%' },
];

const editAverage = (_: Event, { item }: { item: Co2CountryAverage }) => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(Co2AverageForm),
    data: item,
  });
};

const addAverage = () => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(Co2AverageForm),
  });
};

const filterTitle = ref<string>('');
const filteredAverages = computed(() =>
  questions.value.filter((v) =>
    filterTitle.value
      ? v.country.toLowerCase().indexOf(filterTitle.value.toLowerCase()) !==
          -1 ||
        v.category.title
          .toLowerCase()
          .indexOf(filterTitle.value.toLowerCase()) !== -1
      : true,
  ),
);

function updateFilter(filters: { filter: string; filterTitle: string }) {
  filterTitle.value = filters.filterTitle;
}

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createElementVNode("h2", null, [
        _cache[0] || (_cache[0] = _createTextVNode("CO₂ Averages ")),
        _createVNode(CurrentLanguage)
      ]),
      _createVNode(ListFilter, { onFilter: updateFilter }),
      _createVNode(_component_v_data_table, {
        density: "compact",
        headers: headers,
        items: filteredAverages.value,
        "onClick:row": editAverage,
        itemsPerPage: "25",
        hover: ""
      }, {
        "item.categories": _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(item.category.title), 1)
        ]),
        "item.country": _withCtx(({ item }) => [
          (item.country === _unref(OneEarth))
            ? (_openBlock(), _createBlock(_component_v_chip, {
                key: 0,
                density: "compact",
                color: "info"
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode("One Earth")
                ])),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(countryName)(item.country)), 1))
        ]),
        _: 1
      }, 8, ["items"]),
      _createVNode(_component_v_btn, {
        onClick: addAverage,
        color: "success",
        class: "mr-4"
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode("Add Average")
        ])),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})